import { deleteUploadedAttachment } from "../../services/ideas.service"
import "./uploadAttachment.styles.css"
import videoLogo from '../../assets/images/video.svg'
import docLogo from '../../assets/images/document.svg'
import mp3Logo from '../../assets/images/Audio.svg'


export const UploadedAttachment = ({ file, removeAttachment }) => {
    const isUploading = file.isUploading
    let icon
    console.log(file.type)
    if(file.type == 'video/mp4') {
        icon = videoLogo
    }
    else if(file.type == "application/pdf") {
        icon = docLogo
    }
    else if(file.type == "audio/mpeg") {
        icon = mp3Logo
    }
    else {
        icon = file.path
    }

    const deleteAttachment = async () => {
        const response = await deleteUploadedAttachment(file.data.fileName)
        if(response.status == 200) {
            removeAttachment(file.path)
        }
    }
    return (
        <>
            { !isUploading && <div className="col-lg-3 col-12">
                <div className="card">
                    <div className="card-header p-0" style={{backgroundColor: "#05acc4"}} >
                        <div className="card rounded-5 mb-0 upload-logo" style={{ background: `url(${icon})`}} ></div>
                        <a data-action="close" className="img-close" onClick={deleteAttachment}><i className="fas fa-times-circle text-white font-20"></i></a>
                    </div>
                </div>
            </div> }
        </>
    )
}